import React from 'react';
import RaciMatrix from '../components/RaciMatrix';
import Pageheader from '../utils/headerHelment';

const RaciMatrixView = () => (
    <>
        <Pageheader title="LENS - RACI Matrix" />
        <RaciMatrix />
    </>
);

export default RaciMatrixView;
